import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2UploadOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path d="M6 20H4v8h22.6l1.4-2H6zM26 20h2v4h-2z" /><path d="M15 7.761V24h2V7.761l7.303 7.1 1.394-1.433L16 4l-9.697 9.428 1.394 1.433z" /></svg>
);
